import Api, { params } from '../modules/Api.js';

import { IS_LOADING, ISNT_LOADING } from './isLoading';
import { SET_ERROR, RESET_ERROR } from './error';

export const GET_INVOICES_REQUESTED = 'invoices/GET_INVOICES_REQUESTED';
export const GET_INVOICES_SUCCESSFUL = 'invoices/GET_INVOICES_SUCCESSFUL';
export const GET_INVOICES_FAILED = 'invoices/GET_INVOICES_FAILED';

export const INVOICES_DOWNLOAD_REQUESTED =
  'invoices/INVOICES_DOWNLOAD_REQUESTED';
export const INVOICES_DOWNLOAD_SUCCESSFUL =
  'invoices/INVOICES_DOWNLOAD_SUCCESSFUL';
export const INVOICES_DOWNLOAD_FAILED = 'invoices/INVOICES_DOWNLOAD_FAILED';

const initialState = {
  invoices: [],
};

export default function Invoices(state = initialState, action) {
  switch (action.type) {
    case GET_INVOICES_SUCCESSFUL:
      return {
        ...state,
        invoices: action.invoices,
      };
    case GET_INVOICES_FAILED:
      return initialState;
    case INVOICES_DOWNLOAD_SUCCESSFUL:
      return {
        ...state,
        download: { file: action.download.file, name: action.download.name },
      };
    case INVOICES_DOWNLOAD_FAILED:
      return state;
    default:
      return state;
  }
}

export const getInvoices = () => async (dispatch) => {
  dispatch({ type: RESET_ERROR });
  dispatch({ type: IS_LOADING });
  dispatch({ type: GET_INVOICES_REQUESTED });

  return Api('/invoices', { params: params })
    .then((res) => {
      dispatch({
        type: GET_INVOICES_SUCCESSFUL,
        invoices: res.data,
      });
      dispatch({ type: ISNT_LOADING });
    })
    .catch((err) => {
      dispatch({ type: GET_INVOICES_FAILED });
      if (err?.response?.status !== 401) {
        dispatch({
          type: SET_ERROR,
          value: err,
        });
      }
      dispatch({ type: ISNT_LOADING });
    });
};
